import { Currency } from "@src/components/payments/payments.types";

export enum CurrenciesIDEnum {
    USD = 1,
    MXN = 2
}

const CurrencyToIdMap: Record<Currency, CurrenciesIDEnum> = {
    [Currency.USD]: CurrenciesIDEnum.USD,
    [Currency.MXN]: CurrenciesIDEnum.MXN
};

// Function to get ID from currency string
export function getCurrencyId(currencyString: string | undefined): CurrenciesIDEnum | undefined {
    if (!currencyString) return undefined;
    return CurrencyToIdMap[currencyString as Currency];
}